export const apiPath = '/v1/secret_keys';
const actionType = 'SECRET_KEYS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
